var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"j_comm_notification"},[_c('span',{staticClass:"notice_text"},[_vm._v("※ NOTICE : ")]),_c('span',{staticClass:"notice_value"},[_vm._v(_vm._s(_vm.notification))])])}
var staticRenderFns = []

export { render, staticRenderFns }